export { default } from "./src/lozenge";
